import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

createApp(App).use(router).mount('#app')

console.log('Most likely, you are here to enjoy the photos, not to wank around my code. Cut the crap and fuck off, mate.')
